import React from "react";
import './ButtonAll.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function ButtonAll(props) {

    let labelPhone = props.labelPhone;
    if (props.labelPhone === undefined) {labelPhone= props.label}
    return (
        <ChangeLink to={props.ssilka} lang = {props.lang}  style={{textDecoration: 'none'}}  activeClassName={props.activeClassName}>
            <div className={props.className} >
                <nobr className="StandartNoPhone">{props.label}</nobr>
                <nobr  className="StandartPhone">{labelPhone}</nobr>
            </div>
        </ChangeLink>

)}

export default ButtonAll

